import { IAddOnPackageList, IMainPackageList } from './type';

import axiosInstance from 'services/common/instance';

export const getMainPackagesService = async (): Promise<IMainPackageList> => {
  const res = await axiosInstance.get('service-packages/pricing-list');
  return res.data;
};

export const getAddOnPackagesService = async (): Promise<IAddOnPackageList> => {
  const res = await axiosInstance.get('service-package-add-ons/pricing-list');
  return res.data;
};

export const getAddOnSuccessService = async (): Promise<IAddOnPackageList> => {
  const res = await axiosInstance.get('service-package-add-ons/pricing-list');
  return res.data;
};
